import { PLUME_DISCORD_URL } from '@/constants/shared';
import { Icon } from '@chakra-ui/react';
import { FaDiscord } from 'react-icons/fa6';
import { NavButton, NavButtonProps } from './nav-button';

export const DiscordButton = (props: Omit<NavButtonProps, 'href'>) => (
  <NavButton variant="ghost" href={PLUME_DISCORD_URL} target="_blank" p={0} {...props}>
    <Icon boxSize={6} color="fg.muted">
      <FaDiscord />
    </Icon>
  </NavButton>
);
